import React, { useEffect, useState } from "react";
import {
    Modal,
    Box,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
} from "@mui/material";
import { formatDate } from "../../../Components/CommonFunctions/CommonFunctions";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";
import { Colors } from "../../../Styles/Colors";

const StoreIndentReceivePop = ({ open, handleClose, Indentdata, postIndentReceive, errorMessage, forReceive = false, forApprove = false }) => {
    const [productList, setProductList] = useState([]);

    useEffect(() => {
        // getPurchaseindentList()
        let NewData = Indentdata?.line_details?.map((product) => ({
            ...product,
            approved_quantity: forReceive ? product?.approved_quantity : product?.request_quantity // Initialize request_quantity if not present 
        }))
        setProductList(NewData || []);
    }, [Indentdata]);



    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: '65dvw',
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 3,
                    borderRadius: 2,
                }}
            >
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Indent Details
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mb: 2,
                        p: 1,
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                    }}
                >
                    <Box>
                        <Typography variant="subtitle2" fontWeight={600}>From Location</Typography>
                        <Typography variant="body2">{Indentdata?.from_location || "-"}</Typography>
                    </Box>
                    <Typography variant="h6" sx={{ alignSelf: "center" }}>
                        ➝
                    </Typography>
                    <Box>
                        <Typography variant="subtitle2" fontWeight={600}>To Location</Typography>
                        <Typography variant="body2">{Indentdata?.to_location || "-"}</Typography>
                    </Box>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <Typography>
                        <strong>Indent Date:</strong> {Indentdata?.indent_date ? formatDate(Indentdata.indent_date) : "-"}
                    </Typography>
                    <Typography>
                        <strong>Indent No:</strong> {Indentdata?.indent_number || "-"}
                    </Typography>
                </Box>

                <TableContainer component={Paper} sx={{ mb: 2, height: "48dvh", overflowY: "auto" }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                {forReceive ? null : <TableCell className='eMed_Pat_Bill_Tbl_Header'></TableCell>}
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>S.No</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>Product Name</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>Manufacturer</TableCell>
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>Model/Serial No</TableCell>
                                {forReceive ? <TableCell className='eMed_Pat_Bill_Tbl_Header'>Batches</TableCell> : null}
                                <TableCell className='eMed_Pat_Bill_Tbl_Header'>{forReceive ? "Transfered Qty" : "Requested Qty"}</TableCell>
                                {forReceive ? null : <TableCell className='eMed_Pat_Bill_Tbl_Header'>{"Approved Qty"}</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {productList.map((product, index) => (
                                <TableRow key={product.id}>
                                    {(forReceive) ? null : <TableCell>
                                        <Checkbox
                                            size="small"
                                            checked={product?.selected || false}
                                            disabled={product?.transfer_status === "Cancelled" || false}
                                            onChange={() => {
                                                setProductList((prevRows) =>
                                                    prevRows.map((row, RowIndex) =>
                                                        RowIndex === index ? {
                                                            ...row,
                                                            selected: !row.selected,
                                                            approved_quantity: row.selected ? row?.request_quantity : "",
                                                        } : row
                                                    )
                                                );
                                            }}
                                        /></TableCell>}
                                    <TableCell sx={{ color: product?.transfer_status === "Cancelled" ? Colors?.red : "black" }}>{String(index + 1).padStart(2, "0")}</TableCell>
                                    <TableCell sx={{ color: product?.transfer_status === "Cancelled" ? Colors?.red : "black" }}>{product.product_name || "-"}</TableCell>
                                    <TableCell sx={{ color: product?.transfer_status === "Cancelled" ? Colors?.red : "black" }}>{product.manufacturer_name || "-"}</TableCell>
                                    <TableCell sx={{ color: product?.transfer_status === "Cancelled" ? Colors?.red : "black" }}>{product.model_no || "-"}</TableCell>
                                    {forReceive ? <TableCell>{
                                        product?.batch_detail?.length > 0 ? product?.batch_detail?.map((batch, index) => (
                                            <Typography fontSize={'0.8vw'}>{`${batch?.batch_no} / ${batch?.expiry_date} / ${batch?.quantity}`}</Typography>
                                        )) : "-"
                                    }</TableCell> : null}
                                    <TableCell sx={{ color: product?.transfer_status === "Cancelled" ? Colors?.red : "black" }}>{(forReceive ? product.transfer_quantity : product.request_quantity) || 0}</TableCell>
                                    {forReceive ? null : <TableCell>
                                        <TextField
                                            size="small"
                                            variant="outlined"
                                            value={(forReceive ? product.received_quantity : product.approved_quantity) || ""}
                                            disabled={product?.selected || product?.transfer_status === "Cancelled" || false}
                                            inputProps={{ maxlength: 5 }}
                                            onChange={(e) => {
                                                let newValue = e.target.value;
                                                if ((CommonValidation.numberOnly(newValue) && (+newValue >= 0)) || newValue === "") {
                                                    setProductList((prevRows) => prevRows.map((row, rowIndex) => rowIndex === index ? { ...row, approved_quantity: newValue } : row));
                                                }
                                            }}
                                            sx={{ width: 60 }}
                                        />
                                    </TableCell>}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button size='small' variant="outlined" onClick={handleClose} sx={{ mr: 2 }}>
                        Close
                    </Button>
                    {forReceive ? null :
                        <Button size='small' variant="contained" color="error" disabled={productList?.every((list) => !list?.selected)} onClick={() => postIndentReceive({ line_items: productList?.filter((item) => (item?.transfer_status !== "Cancelled" && item?.selected)), indent_data: Indentdata }, true)} sx={{ textTransform: "capitalize", mr: 2 }}>
                            Cancel Selected Product
                        </Button>}
                    <Button size='small' variant="contained" disabled={productList?.some((list) => list?.selected)} onClick={() => postIndentReceive({ line_items: productList?.filter((item) => item?.transfer_status !== "Cancelled"), indent_data: Indentdata })} sx={{ textTransform: "capitalize" }}>
                        {forReceive ? "Receive Products" : "Approve Request"}
                    </Button>
                </Box>
            </Box>
        </Modal >
    );
};

export default StoreIndentReceivePop;
